import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../shared/shared.module';
import { VersionRoutingModule } from './version-routing.module';
import { VersionComponent } from './version.component';
import { NgxMaskModule, IConfig } from 'ngx-mask'

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        NgxMaskModule.forRoot(),
        SharedModule,
        VersionRoutingModule
    ],
    declarations: [VersionComponent],
    exports: [VersionComponent],
    providers: []
})
export class VersionModule {}
